import styled from 'styled-components/macro'
import { transparentize } from 'polished'

import { Href } from 'components/ui'

export const Section = styled.section`
  margin: 0 auto;
  padding: 3.2rem 1.6rem;
  width: 100%;
  max-width: 66.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.4rem;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 5.4rem 3.2rem;
    max-width: 72.8rem;
  `};
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const StyledLink = styled(Href)`
  padding: 1.2rem;
  display: inline-flex;
  justify-content: space-between;
  gap: 0.8rem;
  width: 100%;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.43;
  text-align: left;
  letter-spacing: -0.03rem;
  color: ${(props) => props.theme.color.text};
  background-color: ${(props) => props.theme.color.buttonBgThird};
  border: 0.1rem solid;
  border-color: ${(props) => props.theme.color.buttonBgThird};
  border-radius: 0.8rem;
  transition: all 0.26s ease;
  &:disabled {
    opacity: ${(props) => props.theme.opacity.opacity05};
  }
  &:hover:not([disabled]),
  &:focus:not([disabled]),
  &:active:not([disabled]) {
    box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.5, props.theme.color.buttonBgThird)};
  }
`
